import { useEffect, useRef } from 'react'

const isScrollable = (element: HTMLElement): boolean => {
  const overflowY = window.getComputedStyle(element).overflowY
  return overflowY !== 'hidden' && overflowY !== 'visible'
}

const getScrollParent = (
  node: Node | null | undefined,
): HTMLElement | Window | null | undefined => {
  if (!node) {
    return null
  } else if (
    node instanceof HTMLElement &&
    isScrollable(node) &&
    node.scrollHeight >= node.clientHeight
  ) {
    return node
  }

  return getScrollParent(node.parentNode) || window
}

export default function useScrollOutside(
  ref: React.RefObject<HTMLElement>,
  callback: () => void,
) {
  const callbackRef = useRef<() => void>(callback)
  const scrollParentRef = useRef<HTMLElement | Window | null | undefined>(null)
  useEffect(() => {
    callbackRef.current = callback
  }, [callback])
  useEffect(() => {
    const handleScroll = () => callbackRef.current()

    scrollParentRef.current = getScrollParent(ref.current)

    if (scrollParentRef.current) {
      scrollParentRef.current.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (scrollParentRef.current) {
        scrollParentRef.current.removeEventListener('scroll', handleScroll)
      }
    }
  }, [ref])
}
